import React, { useState, useEffect } from 'react'
import MarkerTooltip from './MarkerTooltip'

import { isMobile } from '../../../../helpers/mobile'
import { pointMarkerPolygon } from '../../../../helpers/Canvas/polygon'
import inside from '../../../../helpers/Canvas/inside'
import {
  isInvalidIOSSize,
  calculateIOSCanvasSize,
  replaceCoordinates
} from '../../../../helpers/Canvas/size'


const MarkerTooltipsCollection = ({
  map,
  mouseX,
  mouseY,
  pointRadius,
  coordinates,
  newCoordinates,
  onClick
}) => {
  const [markers, setMarkers] = useState([])
  const [isMobileDevice] = useState(isMobile())

  useEffect(() => {
    fetchCoordinates()
  }, [coordinates, newCoordinates])

  useEffect(() => {
      setMarkers(
        markers.map(m => ({
          ...m,
          show: inside([mouseX, mouseY], pointMarkerPolygon(m.x, m.y, pointRadius, isMobileDevice))
        }))
      )
    
  }, [mouseX, mouseY])

  const fetchCoordinates = () => {
    const newMarkers = []

    ;(coordinates || []).forEach(c => {
      if (c.items && c.items.length) {
        c.items.forEach(i => {
          if (i.meta
            && i.meta.type === 'point'
            && i.title) {
            newMarkers.push(
              toNewMarkerObj(i.meta.x, i.meta.y, i.title)
            )
          }
        })
      }
    })

    ;(newCoordinates || []).forEach(c => {
      if (c.type === 'point' && c.title) {
        newMarkers.push(
          toNewMarkerObj(c.x, c.y, c.title)
        )
      }
    })

    setMarkers(newMarkers)
  }

  const toNewMarkerObj = (x, y, title) => {
    const invalidIOSSize = isInvalidIOSSize(map.width, map.height)
    const mapSize = { width: Number(map.width), height: Number(map.height) }
    const calculatedSize = invalidIOSSize
      ? calculateIOSCanvasSize(map.width, map.height)
      : null
    const coords = calculatedSize
      ? replaceCoordinates(
        calculatedSize.width,
        calculatedSize.height,
        mapSize.width,
        mapSize.height,
        [x, y]
      )
      : [x, y]
    return {
      x:coords[0],
      y: isMobileDevice ? +coords[1] + 52 : coords[1],
      title: title,
      //show: !!isMobileDevice
    }
  }

  return (
    <React.Fragment>
      {
        markers.map((marker, idx) => (
          <MarkerTooltip marker={marker} key={idx} onClick={onClick} />
        ))
      }
    </React.Fragment>
  )
}

export default MarkerTooltipsCollection
